import React, { Component } from "react";
import styled from "styled-components";
import AppConfig from "../../Config";
import * as Icon from "../Icon";
import * as Css from "../Css";

export const Absolute = styled.div`
  ${Css.Absolute} ${props => props.css};
`;

export const Figure = styled.figure`
  ${Css.Background} ${props => props.css};
`;

export const Center = styled.div`
  ${Css.Center} ${props => props.css};
`;

export const MaxWidth = styled.div`
  max-width: ${props => props.width}px;
  margin: ${props => props.margin || "0 auto"};
  ${props => props.css};
`;

export const Container = styled.div`
  ${props => props.css};
`;

export const Row = styled.div`
  display: flex;
  align-items: ${props => props.align || "stretch"};
  justify-content: ${props => props.justify || "flex-start"};
  flex-wrap: ${props => (props.wrap ? "wrap" : "nowrap")};
  ${props => props.css};
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.align || "stretch"};
  justify-content: ${props => props.justify || "flex-start"};
  ${props => props.css};
`;

export const Button = styled.button`
  display: inline-block;
  border: none;
  padding: 8px 12px;
  text-decoration: none;
  cursor: pointer;
  text-align: center;
  transition: background 250ms ease-in-out, transform 150ms ease;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: ${props => props.color || "teal"};
  color: ${props => props.textColor || "#fff"};
  font-size: ${props => props.fontSize || "20px"};

  & :hover {
    font-weight: 900;
    background: ${props => props.hoverColor || props.color || "teal"};
  }

  & :focus {
    background: ${props => props.focusColor || props.color || "teal"};
    outline: none;
  }

  & :active {
    transform: scale(0.88);
  }

  & :disabled {
    background: ${props => props.disableColor || "#ccc"};
    color: ${props => props.disableTextColor || "#666"};
  }

  ${props => props.css || ""};
`;

export const FlatButton = styled.button`
  display: inline-block;
  border: none;
  padding: 8px 12px;
  margin-left: 10px;
  text-decoration: none;
  cursor: pointer;
  text-align: center;
  transition: font-weight 250ms ease-in-out, transform 150ms ease;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  color: ${props => props.color || "black"};
  font-size: ${props => props.fontSize || "16px"};

  & :hover {
    transform: scale(1.05);
    color: ${props => props.color || "black"};
  }

  & :focus {
    color: ${props => props.color || "black"};
    outline: none;
  }

  & :active {
    transform: scale(0.88);
  }

  & :disabled {
    color: ${props => props.color || "#ccc"};
  }

  ${props => props.css || ""};
`;

export const FormField = styled.div`
  margin-bottom: 20px;
  display: flex;

  & > label {
    margin-right: 10px;
    flex: 1;
    font-weight: 700;
  }

  & > input {
    border: none;
    border-bottom: 1px solid #ccc;
    text-align: right;
    width: ${props => props.inputWidth || "100px"};
  }

  & > input:focus {
    outline: none;
  }

  & > select {
    width: ${props => props.selectWidth || props.inputWidth || "100px"};
    text-align-last: right;
  }

  & > select > option {
    direction: rtl;
  }

  ${props => props.css || ""};
`;

export const Spinner = styled.div`
  background-image: url("/spinner.gif");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  display: ${props => props.display || "inline-block"};
  width: ${props => props.size || "100px"};
  height: ${props => props.size || "100px"};

  ${props => props.css || ""};
`;

export const OutlineButton = styled.button`
  border: 1px solid #755b41;
  padding: 15px 5px;
  min-width: 150px;
  background-color: transparent;
  font-size: 18px;
  color: #755b41;
  cursor: pointer;

  :focus {
    outline: none;
  }

  ${props => props.css || ""};
`;

export const SubmitButton = (() => {
  const Wrapper = styled.div`
    position: relative;
    & > .loading-container {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      background-color: rgba(255, 255, 255, 0.6);
      z-index: 1;
    }

    & > button {
      width: 160px;
      height: 40px;
      border: 0;
      font-size: 14px;
      color: ${AppConfig["global"].themeColor};
      background-color: #fff;
      cursor: pointer;
      outline: 0;

      &:disabled {
        background-color: #a9a9a9;
        color: #fff;
        opacity: 0.9;
        cursor: not-allowed;
      }
    }
  `;
  return props => {
    let { text, onClick, loading = false, disabled = false } = props;
    return (
      <Wrapper>
        {loading && (
          <div className="loading-container">
            <Spinner size={"50px"} />
          </div>
        )}
        <button onClick={onClick} disabled={disabled}>
          {text}
        </button>
      </Wrapper>
    );
  };
})();

export class QuantityInput extends React.Component {
  render() {
    let { value, onChange, extraCss, disabled = false } = this.props;

    return (
      <QuantityInput.Wrapper extraCss={extraCss}>
        <QuantityInput.Select
          disabled={disabled}
          value={value}
          onChange={onChange}
        >
          {Array.apply(null, { length: 20 }).map((n, index) => (
            <option key={index + 1} value={index + 1}>
              {index + 1}
            </option>
          ))}
        </QuantityInput.Select>
        <div>
          <Icon.ArrowDownward color="#808080" size={18} />
        </div>
      </QuantityInput.Wrapper>
    );
  }

  static Select = styled.select`
    width: 100%;
    height: 30px;
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    background-color: #fff;
    color: ${props => (props.disabled ? "#adadad" : "#343434")};
    font-size: 14px;
    outline: none;
    padding-right: 24px;
    text-align-last: ${props => props.align || "center"};
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: "";
    cursor: pointer;
  `;

  static Wrapper = styled.div`
    width: 81px;
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    ${props => props.extraCss};

    & > div {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      border-left: 1px solid #e9e9e9;
      height: 100%;
      pointer-events: none;
      right: 0;
    }
  `;
}

export const AnimatedButton = styled.button`
   /* style refer: https://cssfx.dev/ bubble2 */
  border: 1px solid #755b41;
  padding: 15px 10px;
  min-width: 200px;
  background-color: transparent;
  letter-spacing: 3px;
  font-size: 18px;
  color: #755b41;
  cursor: pointer;
  z-index: 1;
  position: relative;
  font-size: inherit;
  font-family: inherit;
  color: #755b41;
  outline: none;
  background-color: transparent;
  overflow: hidden;
  transition: color 0.4s ease-in-out;

  &::before {
    content: "";
    z-index: -1;
    position: absolute;
    top: 100%;
    left: 100%;
    width: 2em;
    height: 2em;
    border-radius: 50%;
    background-color: #755b41;
    transform-origin: center;
    transform: translate3d(-50%, -50%, 0) scale3d(0, 0, 0);
    transition: transform 0.45s ease-in-out;
  }

  &:hover {
    cursor: pointer;
    color: white;
  }

  &:hover::before {
    transform: translate3d(-50%, -100%, 0) scale3d(15, 15, 15);
  }
    }

  ${props => props.css || ""};
`;

export const BrownButton = styled.button`
  max-width: 120px;
  width: 100%;
  min-height: 40px;

  border-radius: 20.5px;
  border: 0px;

  cursor: pointer;
  background-color: #755b42;
  text-align: center;
  font-size: 14px;
  color: white;

  & :focus {
    outline: none;
  }

  & :active {
    position: relative;
    top: 1px;
    left: 1px;
  }

  ${props => props.css || ""};
`;

export const SectionTitle = styled.div`
  margin-bottom: ${props => (props.haveMarginBottom ? 24.5 : 0)}px;
  font-weight: bold;
  font-size: 28px;
  color: #4e4e4e;

  @media screen and (max-width: 600px) {
    margin-bottom: ${props => (props.haveMarginBottom ? 15 : 0)}px;
    font-size: 20px;
  }

  ${props => props.css || ""};
`;

export const SectionLine = styled.div`
  max-width: 1035px;
  width: 100%;
  height: 1px;
  transform: scaleY(0.4);
  background-color: #b4b9c4;
  ${props => props.css || ""};
`;

export const SectionContainer = styled.div`
  padding: 30px;
  max-width: 1035px;
  width: 100%;
  min-height: 204px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & .text {
    margin-bottom: 30px;
    line-height: 25px;
    white-space: pre-wrap;
    text-align: center;
    letter-spacing: 0.28px;
    font-size: 14px;
    color: #4e4e4e;
  }

  @media screen and (max-width: 600px) {
    & .text {
      white-space: normal;
    }
  }

  @media screen and (max-width: 500px) {
    padding: 20px;
  }
`;

export class SeeMoreButton extends Component {
  render() {
    let { label, onClick, css } = this.props;
    return (
      <SeeMoreButton.Wrapper onClick={onClick} css={css}>
        <SeeMoreButton.Label css="margin-right: 5px;">
          {label}
        </SeeMoreButton.Label>
        <SeeMoreButton.Icon src="/images/pages/landing/icon02.png" />
      </SeeMoreButton.Wrapper>
    );
  }

  static Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 5px 10px;

    :hover {
      border-radius: 10px;
      background-color: #f0f0f0;
    }

    :active {
      position: relative;
      top: 1px;
      left: 1px;
    }

    ${props => props.css || ""};
  `;

  static Label = styled.div`
    line-height: 20px;
    font-size: 14px;
    color: #4e4e4e;
    ${props => props.css || ""};
  `;

  static Icon = styled.img`
    width: 4px;
    height: 4px;
  `;
}
